module.exports = __webpack_public_path__ + "static/media/omar.cb63e95e.png";